// @ts-strict-ignore
import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  static values = { error: String, componentName: String, componentId: String }

  connect() {
    const env = window.__APP_ENV__
    const version = window.__APP_SEMANTIC_VERSION__ || window.__APP_VERSION__
    const sentryDSN = window.__APP_SENTRY_DSN__
    const brand = window.__BRAND__
    const spaceId = brand === 'money' ? 't014ej9w3ur1' : 'n36b8lzdmgnp'
    if (env === 'production') {
      window.Sentry.init({
        dsn: sentryDSN,
        environment: env,
        release: version,
        initialScope: {
          tags: {
            release: version,
            environment: 'production',
            runtime: 'client',
            contentfulUrl: `https://app.contentful.com/spaces/${spaceId}/entries/${this.componentIdValue}`,
            brand: brand,
          },
        },
      })
      window.Sentry.captureException(new Error(this.errorValue))
    }
  }
}
